import React, { useState } from 'react';
import {SimulatorOfferModel,DiscountModel,YesNo} from '../models/superbit-api-models'
import { StatOptions } from 'fs';
import moment from 'moment';
import { AyalonDiscount } from './_AyalonDiscount';
type Props = {
    offer:SimulatorOfferModel | null;
    onChanged:any;
  };
  
  
 

export class AyalonOffer extends React.Component<Props,Props>
{
    constructor(props:any) {
        super(props); 
        console.log('ayalonData', this.props.offer);
        this.state = {
          offer:this.props.offer,
          onChanged:null
        }
        
      }

      componentDidMount(){
        console.log('ayalonData', this.props.offer);
      }


      updateDiscount=async (discount:DiscountModel) => {
        //console.log('updateDiscount2',this.state.offer.discounts!=null);
        if(this.state.offer!=null && this.state.offer.activeDiscounts!=null){
            console.log('updateDiscount',1);
            var offer = this.state.offer;
        var discounts = this.state.offer.activeDiscounts;
         

            //Find index of specific object using findIndex method.    
            var objIndex = discounts.findIndex((obj => obj.id == discount.id));
            discounts[objIndex] = discount;

            offer.discounts = discounts;

            await this.setState({offer: offer}, ()=>{
                this.props.onChanged(this.state.offer);
              });

            
        }
      }
      
      
    render() {

       

        return (  <>
        <div className="title-row flex-space-between flex-centered">
            <div className="title">
                הנחה
            </div>
            {/* <div>
                <button className="button small add-new">
                    <div className="icon"></div>
                </button>
            </div> */}
        </div>
        <div className="form-table-row flex-space-between flex-centered">
        <div className="form-table-column">
                <div className="title">
                    הנחה
                </div>
                
            </div>
            <div className="form-table-column">
                <div className="title">
                    הנחת מנהל
                </div>
                
            </div>
            <div className="form-table-column">
                <div className="title">
                    הנחת מחשבון
                </div>
                
            </div>
        </div>
        <div>

        {this.state.offer!=null && this.state.offer.activeDiscounts!=null && this.state.offer.activeDiscounts.length>0? this.state.offer.activeDiscounts.map((discount: DiscountModel) =>{
return(
    <>
    <AyalonDiscount discount={discount} onChanged={(e: any)=>this.updateDiscount(e)} /> 
    </>
)
  }):<div className="note-row">
   לא הוספת הנחות
</div>}


                                    
</div>




                                    
                                    
                                    
                                    
        </>
        );
      }
  }
